import { render, staticRenderFns } from "./carrierPortrait.vue?vue&type=template&id=61539c6e&scoped=true"
import script from "./carrierPortrait.vue?vue&type=script&lang=ts"
export * from "./carrierPortrait.vue?vue&type=script&lang=ts"
import style0 from "./carrierPortrait.vue?vue&type=style&index=0&id=61539c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61539c6e",
  null
  
)

export default component.exports